import { get as getMouvementClient, getAllByPiece } from '@/api/mouvementClient/index';
import { SENS_VENTE } from '@/configuration/devisConf';
import preparationListePieces from '@/services/remiseBancaire/reglement/preparationListePieces';
import * as mouvementClientConf from '@/configuration/mouvementClient/mouvementClientConf';
import getEmptyMouvementClient from '@/services/remiseBancaire/reglement/getEmptyMouvementClient';

async function getPieces(query, mouvementClientReglement,
  remiseBancaireId, societeActiveId) {
  const objectFilter = {
    query: query,
    MaxResultCount: 9999,
    SkipCount: 0,
    societeId: societeActiveId,
  };
  const response = await getAllByPiece(objectFilter);
  preparationListePieces(response.data.result.items, mouvementClientReglement, remiseBancaireId);
  const mouvement = response.data.result.items;
  return mouvement;
}

async function getMouvement(data) {
  const tmp = await getMouvementClient(data.id);
  const mouvementClientReglement = tmp.data.result;
  return mouvementClientReglement;
}

export default async function getMouvementInfos(data, societeActiveId) {
  let mouvementClientReglement = getEmptyMouvementClient();
  const mouvementClient = {
    dataTable: [],
    resteALettrer: 0,
    mouvementClientReglement: null,
  };
  mouvementClientReglement = await getMouvement(data);
  const idsMouvementClientLettres = [];
  if (mouvementClientReglement.lettrages !== null) {
    mouvementClientReglement.lettrages.forEach(lettrage => {
      if (lettrage.mouvementClient1Id !== mouvementClientReglement.id) {
        idsMouvementClientLettres.push(lettrage.mouvementClient1Id);
      }
      if (lettrage.mouvementClient2Id !== mouvementClientReglement.id) {
        idsMouvementClientLettres.push(lettrage.mouvementClient2Id);
      }
    });
  }
  if (mouvementClientReglement.mouvementClientEnfants !== undefined
      && mouvementClientReglement.mouvementClientEnfants !== null) {
    mouvementClientReglement.mouvementClientEnfants.forEach(mcEscompte => {
      if (mcEscompte.lettrages === null) return;
      mcEscompte.lettrages.forEach(lettrageEscompte => {
        if (lettrageEscompte.mouvementClient1Id !== mcEscompte.id) {
          idsMouvementClientLettres.push(lettrageEscompte.mouvementClient1Id);
        }
        if (lettrageEscompte.mouvementClient2Id !== mcEscompte.id) {
          idsMouvementClientLettres.push(lettrageEscompte.mouvementClient2Id);
        }
      });
    });
  }

  const parameters = {
    ids: idsMouvementClientLettres,
    tiersId: mouvementClientReglement.tiersId,
    societeId: data.remiseBancaire.societeId,
    brouillard: false,
  };
  if (!mouvementClientReglement.tiersId) {
    parameters.sensPiece = SENS_VENTE;
  }
  if (idsMouvementClientLettres.length > 0) {
    const dataTable = await getPieces(parameters, mouvementClientReglement,
      data.remiseBancaireId, societeActiveId);

    if (mouvementClientReglement.mouvementClientEnfants !== null) {
      mouvementClientReglement.mouvementClientEnfants.forEach(mvtEscompte => {
        if (mvtEscompte.typeDePiece !== mouvementClientConf.ESCOMPTE) return;
        dataTable.forEach(piece => {
          if (piece.pieceId !== mvtEscompte.factureId) return;
          piece.montantEscompte = mvtEscompte.credit;
          piece.escompteApplicable = true;
        });
      });
    }
    mouvementClient.dataTable = dataTable;
  }
  mouvementClient.resteALettrer = mouvementClientReglement.resteALettrer;
  mouvementClient.mouvementClientReglement = mouvementClientReglement;
  return mouvementClient;
}
